import React from 'react'

export default function LoadProjetCard() {
  return (
    <div>
        <div role="status" className="space-y-8  animate-pulse md:space-y-0 md:space-x-8  md:items-center  rounded-md dark:dark:bg-gray-700 dark:border-gray-700 dark:hover:dark:bg-gray-600/50 dark:text-zinc-300">
            
            <div className="flex items-center justify-center overflow-hidden w-full h-48 bg-gray-300 rounded-md rounded-b-none dark:dark:bg-gray-500  pb-0 h-72">
                <svg className="w-10 h-10 text-gray-200 dark:text-gray-600" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
                    <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
                </svg>
            </div>
            <div className=" pb-4  py-4 p">
                <div className="flex gap-2">
                    <div className="h-2.5 bg-gray-200 rounded-full dark:dark:bg-gray-600 w-4 mb-4"></div>
                    <div className="h-2.5 bg-gray-200 rounded-full dark:dark:bg-gray-600 w-48 mb-4"></div>
                    <div className="h-2.5 bg-gray-200 rounded-full dark:dark:bg-gray-600 w-8 mb-2.5"></div>
                </div>
                <div className="h-2 bg-gray-200 rounded-full dark:dark:bg-gray-600 w-10/12 max-w-[400px] mb-2.5"></div>
                <div className="flex gap-2">
                    <div className="h-2.5 bg-gray-200 rounded-full dark:dark:bg-gray-600 w-4/12 mb-4"></div>
                    <div className="h-2.5 bg-gray-200 rounded-full dark:dark:bg-gray-600 w-3/12 mb-4"></div>
                </div>
            </div>
            <span className="sr-only">Chargement...</span>
        </div>
    </div>
  )
}
